/* OUP — preuve sociale (étoiles vertes "Trustpilot")
   1) footer dans le drawer mobile
   2) badge dans le header desktop, à gauche du panier */
(function () {
  var STARS =
    '<span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>';

  function injectMobile() {
    var nav = document.querySelector('.navigation.mobile .navigation__menu-content');
    if (!nav) return false;
    if (nav.querySelector('.oup-menu-trust')) return true;
    var d = document.createElement('div');
    d.className = 'oup-menu-trust';
    d.innerHTML =
      '<div class="oup-trust-stars" aria-hidden="true">' + STARS + '</div>' +
      '<div class="oup-trust-txt"><strong>4,7/5</strong> · 2 996 avis vérifiés</div>';
    nav.appendChild(d);
    return true;
  }

  function injectDesktop() {
    var actions = document.querySelectorAll('.header__action');
    if (!actions.length) return false;
    actions.forEach(function (action) {
      if (action.querySelector('.oup-trust-header')) return;
      var b = document.createElement('div');
      b.className = 'oup-trust-header';
      b.setAttribute('aria-hidden', 'true');
      b.innerHTML =
        '<div class="oup-th-stars">' + STARS + '</div>' +
        '<div class="oup-th-txt"><strong>4,7/5</strong> · 2 996 avis</div>';
      var ref = action.lastElementChild;
      var cart = action.querySelector(
        '[data-action="open-cart"], a[href$="/cart"], [href*="/cart"], cart-notification, cart-drawer'
      );
      if (cart) {
        var p = cart;
        while (p && p.parentElement !== action) p = p.parentElement;
        if (p) ref = p;
      }
      try { action.insertBefore(b, ref); }
      catch (e) { action.appendChild(b); }
    });
    return true;
  }

  function tick(times) {
    var a = injectMobile();
    var b = injectDesktop();
    if (a && b) return;
    if (times <= 0) return;
    setTimeout(function () { tick(times - 1); }, 250);
  }
  function start() { tick(10); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-action="toggle-nav"]')) {
      setTimeout(function () { tick(6); }, 200);
    }
  });
  document.addEventListener('shopify:section:load', function () { tick(6); });
})();


/* OUP — apparition/disparition automatique des boutons saisonniers + pills (auto, fuseau Europe/Paris) */
(function(){
  var W={"pack-saint-valentin":[["2026-01-15","2026-02-10"],["2027-01-15","2027-02-10"]],"pack-fete-des-grands-meres":[["2026-02-01","2026-02-25"],["2027-02-07","2027-03-03"]],"pack-paques":[["2026-03-08","2026-03-31"],["2027-03-01","2027-03-24"]],"pack-fete-des-meres":[["2026-05-01","2026-05-27"],["2027-04-30","2027-05-26"]],"pack-fete-des-peres":[["2026-05-25","2026-06-17"],["2027-05-24","2027-06-16"]],"pack-rentree-scolaire":[["2026-08-10","2026-08-30"],["2027-08-10","2027-08-30"]],"pack-fete-des-grands-peres":[["2026-09-07","2026-09-30"],["2027-09-06","2027-09-29"]],"pack-halloween":[["2026-10-05","2026-10-27"],["2027-10-05","2027-10-27"]],"pack-saint-nicolas":[["2026-11-10","2026-12-02"],["2027-11-10","2027-12-02"]],"pack-noel":[["2026-11-20","2026-12-21"],["2027-11-20","2027-12-21"]]};
  var C={"pack-saint-valentin":["#FDE3E7","#E11D48","#FDE7EC"],"pack-fete-des-grands-meres":["#F5E9FB","#9333EA","#F7ECFD"],"pack-fete-des-grands-peres":["#ECFCCB","#4D7C0F","#F2FBE0"],"pack-paques":["#FEF3C7","#B45309","#FEF6DC"],"pack-rentree-scolaire":["#E0F2FE","#0369A1","#E6F4FD"],"pack-halloween":["#FFEAD5","#C2410C","#FFF0E0"],"pack-saint-nicolas":["#FEE2E2","#B91C1C","#FDECEC"],"pack-noel":["#DCFCE7","#166534","#E7F8EE"]};
  var CSS="@media(min-width:1300px){.navigation.horizontal .horizontal-list > .level0.oup-pill{align-self:center !important;display:flex !important;align-items:center !important;}.navigation.horizontal .horizontal-list > .level0.oup-pill > menu-item > a{display:inline-flex !important;align-items:center !important;line-height:1.4 !important;padding:7px 13px !important;border-radius:8px !important;white-space:nowrap;font-weight:700 !important;font-size:14px !important;height:auto !important;min-height:0 !important;background:var(--oup-bd) !important;}.navigation.horizontal .horizontal-list > .level0.oup-pill > menu-item > a,.navigation.horizontal .horizontal-list > .level0.oup-pill > menu-item > a > span{color:var(--oup-fg) !important;}.navigation.horizontal .horizontal-list > .level0.oup-pill > menu-item > a:after{display:none !important;}}@media(max-width:1299.98px){.navigation.mobile.horizontal .horizontal-list > .level0.oup-pill > menu-item{background:var(--oup-bm) !important;border-left:4px solid var(--oup-fg) !important;}.navigation.mobile.horizontal .horizontal-list > .level0.oup-pill > menu-item a,.navigation.mobile.horizontal .horizontal-list > .level0.oup-pill > menu-item span{color:var(--oup-fg) !important;font-weight:700 !important;}}";
  function today(){try{return new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Paris',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date());}catch(e){return new Date().toISOString().slice(0,10);}}
  function active(s,t){var w=W[s];if(!w)return true;for(var i=0;i<w.length;i++){if(t>=w[i][0]&&t<=w[i][1])return true;}return false;}
  function injectCSS(){if(document.getElementById('oup-seasonal-style'))return;var el=document.createElement('style');el.id='oup-seasonal-style';el.textContent=CSS;(document.head||document.documentElement).appendChild(el);}
  function apply(){injectCSS();var t=today();var lis=document.querySelectorAll('.navigation .horizontal-list > .level0');for(var k=0;k<lis.length;k++){var li=lis[k];var a=li.querySelector('menu-item > a');if(!a)continue;var href=a.getAttribute('href')||'';var slug=null;for(var s in W){if(href.indexOf(s)>=0){slug=s;break;}}if(!slug)continue;if(!active(slug,t)){li.style.setProperty('display','none','important');continue;}li.style.removeProperty('display');if(C[slug]){li.classList.add('oup-pill');li.style.setProperty('--oup-bd',C[slug][0]);li.style.setProperty('--oup-fg',C[slug][1]);li.style.setProperty('--oup-bm',C[slug][2]);}}}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',apply);}else{apply();}
  document.addEventListener('shopify:section:load',apply);
  document.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('[data-action="toggle-nav"]')){setTimeout(apply,200);}});
})();
